module.exports = __webpack_public_path__ + "img/BLCA_Neutrophils.fbf32fc1.png";